import { useEffect, useRef, useState } from "react";

export default function App() {
  const [car, setCar] = useState(0);
  const [moto, setMoto] = useState(0);

  const audioContextRef = useRef(null);
  const beepBuffer = useRef(null);
  const motoBuffer = useRef(null);

  useEffect(() => {
    const ctx = new (window.AudioContext || window.webkitAudioContext)({
      latencyHint: "interactive",
    });

    audioContextRef.current = ctx;

    const load = async () => {
      const [b1, b2] = await Promise.all([
        fetch("/beepNew.mp3")
          .then((r) => r.arrayBuffer())
          .then((b) => ctx.decodeAudioData(b)),

        fetch("/motoSound.mp3")
          .then((r) => r.arrayBuffer())
          .then((b) => ctx.decodeAudioData(b)),
      ]);

      beepBuffer.current = b1;
      motoBuffer.current = b2;
    };

    load();

    const unlock = () => {
      if (ctx.state === "suspended") ctx.resume();
    };

    window.addEventListener("pointerdown", unlock, { once: true });

    return () => window.removeEventListener("pointerdown", unlock);
  }, []);

  const play = (buffer) => {
    const ctx = audioContextRef.current;
    if (!ctx || !buffer) return;

    const src = ctx.createBufferSource();
    src.buffer = buffer;
    src.connect(ctx.destination);
    src.start(ctx.currentTime);
  };

  const updateCar = (v) => {
    play(beepBuffer.current);
    setCar((c) => Math.max(0, c + v));
  };

  const updateMoto = (v) => {
    play(motoBuffer.current);
    setMoto((m) => Math.max(0, m + v));
  };

  return (
    <div style={{ height: "100vh" }}>
      {/* VOITURES */}
      <div style={sectionStyle("blue")}>
        <button onPointerDown={() => updateCar(-1)}>-</button>
        <div>
          <h2>{car}</h2>
          <button onClick={() => setCar(0)}>Reset</button>
        </div>
        <button onPointerDown={() => updateCar(1)}>+</button>
      </div>

      {/* MOTOS */}
      <div style={sectionStyle("cyan")}>
        <button onPointerDown={() => updateMoto(-1)}>-</button>
        <div>
          <h2>{moto}</h2>
          <button onClick={() => setMoto(0)}>Reset</button>
        </div>
        <button onPointerDown={() => updateMoto(1)}>+</button>
      </div>
    </div>
  );
}

const sectionStyle = (color) => ({
  height: "50vh",
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
  background: color,
});